/*
  Temporary patch: the "free-shipping" custom element inserts its progress
  message (e.g. "Spend <span class=money>$80.00</span> more...") as literal
  text instead of HTML, so the tags show up raw on screen. This script
  watches the message element and, whenever it detects raw markup sitting
  in the text, re-renders it properly as HTML.

  Self-limiting: once fixed, the text node no longer contains the literal
  "<span" string, so this does not re-trigger itself or loop.
*/
(function () {
  function fixShippingMessage(el) {
    if (!el) return;
    var text = el.textContent;
    if (text && text.indexOf('<span') !== -1) {
      el.innerHTML = text;
    }
  }

  function scanAndFix() {
    document.querySelectorAll('[shipping-message]').forEach(fixShippingMessage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndFix);
  } else {
    scanAndFix();
  }

  var observer = new MutationObserver(function (mutations) {
    var elementsToCheck = new Set();
    mutations.forEach(function (mutation) {
      var node = mutation.target;
      if (node.nodeType === 3) node = node.parentElement; // text node -> parent element
      if (node && node.closest) {
        var el = node.closest('[shipping-message]');
        if (el) elementsToCheck.add(el);
      }
    });
    elementsToCheck.forEach(fixShippingMessage);
  });

  observer.observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();
